export default {
}



// WEBPACK FOOTER //
// src/store/chrome/getters.js